import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "border-bottom mb-3" }
const _hoisted_2 = { class: "mb-3 row" }
const _hoisted_3 = { class: "col-md-8" }
const _hoisted_4 = { class: "border-bottom mb-3" }
const _hoisted_5 = { class: "mb-3 row align-items-center" }
const _hoisted_6 = { class: "col-sm-9" }
const _hoisted_7 = { class: "mb-3 row" }
const _hoisted_8 = { class: "col-sm-9" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "mb-3 row" }
const _hoisted_13 = { class: "col-sm-9" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "mb-3 row" }
const _hoisted_18 = { class: "col-sm-9" }
const _hoisted_19 = { class: "mb-3 row" }
const _hoisted_20 = { class: "col-sm-9" }
const _hoisted_21 = { class: "mb-3 row align-items-start" }
const _hoisted_22 = { class: "col-sm-9 mt-2" }
const _hoisted_23 = { class: "mt-5 mb-3 details" }
const _hoisted_24 = { class: "table-sm mb-3" }
const _hoisted_25 = { class: "val" }
const _hoisted_26 = { class: "val" }
const _hoisted_27 = { colspan: "2" }
const _hoisted_28 = { class: "col-12 offset-3 pb-0 pt-0" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "val" }
const _hoisted_32 = {
  key: 0,
  class: "row"
}
const _hoisted_33 = { class: "col" }
const _hoisted_34 = { class: "val" }
const _hoisted_35 = {
  key: 0,
  class: "val"
}
const _hoisted_36 = {
  key: 1,
  class: "val"
}
const _hoisted_37 = ["href"]

import {Audit, AuditEdit} from "@/audit.types";
import {useAuditStore} from "@/stores/auditStore";
import {clone, convertToUTC} from "@/utils";
import {useFormValidation} from "@/validation";
import {computed, onMounted, ref, watch} from "vue";
import {date, mixed, object, string} from "yup";
import InformationModal from "../Misc/InformationModal.vue";
import FileInput from "../Fields/FileInput.vue";
import AuditDetailsNotices from "./AuditDetailsNotices.vue";
import {BInput, BDatePicker} from "../Fields";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuditDetailsGeneral',
  props: {
    id: {},
    audit: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  },
  emits: ["reload"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const auditStore = useAuditStore();
const editAudit = ref<AuditEdit>();
const uploadReportFile = ref<File | null>();

const schema = object<AuditEdit>({
    startDate: date().required().label("Start Date"),
    plannedEndDate: date()
        .required()
        .label("End Date")
        .when("startDate", (startDate, schema) => {
            if (editAudit.value!.startDate) {
                const dayAfter = new Date(new Date(editAudit.value!.startDate).getTime() + 86400000);
                return schema.min(dayAfter, "End date cannot be earlier than start date");
            }
            return schema;
        }),
    startMonth: date()
        .required()
        .label("Start Month")
        .test(
            "min-date-validation",
            () => `Start Month must be no later than ${editAudit.value?.validationStartMonth}`,
            async (startMonth) => {
                if (!editAudit.value!.validationStartMonth) {
                    return true;
                }
                var e = convertToUTC(new Date(editAudit.value!.validationStartMonth));
                e.setMonth(e.getMonth() + 1);
                e.setDate(0);
                return startMonth <= e;
            }
        ),
    endMonth: date()
        .required()
        .label("End Month")
        .when("plannedEndDate", (plannedEndDate, schema) => {
            if (editAudit.value!.plannedEndDate) {
                var endDate = new Date(editAudit.value!.plannedEndDate);
                const dayAfter = new Date(endDate.getFullYear(), endDate.getUTCMonth() + 1, 1);
                return schema.max(dayAfter, "End month cannot be later than when the Audit is taking place");
            }
            return schema;
        })
        .when("startMonth", (startMonth, schema) => {
            if (editAudit.value!.startMonth) {
                const dayAfter = new Date(editAudit.value!.startMonth.getTime() + 86400000);
                return schema.min(dayAfter, "End month has to be no earlier than start month");
            }
            return schema;
        })
        .test(
            "max-date-validation",
            () => `End Month must be no earlier than ${editAudit.value?.validationEndMonth}`,
            async (endMonth) => {
                if (!editAudit.value!.validationEndMonth) {
                    return true;
                }
                var e = convertToUTC(new Date(editAudit.value!.validationEndMonth));
                e.setMonth(e.getMonth() + 1);
                e.setDate(0);
                return endMonth >= e;
            }
        ),
    auditorName: string().required().label("Auditor Name"),
    auditorEmailAddress: string().email().label("Audit Email Address"),
});
const canShowCancel = computed(
    () =>
        props.runAudits &&
        (props.audit.statusCode == "AN" || props.audit.statusCode == "AP") &&
        (!props.audit.documents || props.audit.documents == 0)
);
const canShowClose = computed(
    () => props.runAudits && props.audit.statusCode == "AP" && props.audit.documents && props.audit.documents != 0
);

const closeAudit = async function () {
    await auditStore.close(props.id!);
    await fetchDetails();
};
const canViewReport = computed(() => props.audit.reportFileId);

const canUploadReport = computed(() => props.runAudits && props.audit.statusCode != "AC" && !props.audit.reportFileId);

const canReplaceReport = computed(() => props.runAudits && props.audit.reportFileId && props.audit.statusCode != "AC");

const canEdit = computed(() => props.runAudits && props.audit.statusCode != "AC");

const isShowUploadReport = ref(false);

const showUploadReport = function () {
    resetValidation();
    isShowUploadReport.value = true;
};

const hideUploadReport = function () {
    isShowUploadReport.value = false;
};

const {handleSubmit, errors, resetValidation} = useFormValidation();

const uploadReportSchema = object().shape({
    file: mixed().required().label("File"),
});

const uploadReport = async function () {
    if (await handleSubmit(uploadReportSchema, {file: uploadReportFile.value})) {
        await auditStore.upload(props.id!, uploadReportFile.value!);
        hideUploadReport();
        await fetchDetails();
        uploadReportFile.value = null;
    }
};

const isShowEditEditor = ref(false);

const showEditEditor = async function () {
    editAudit.value = <AuditEdit>(<unknown>await auditStore.getById(props.id));

    editAudit.value.plannedEndDate = convertToUTC(new Date(props.audit.plannedEndDate));
    editAudit.value.startDate = convertToUTC(new Date(props.audit.startDate));
    let date = convertToUTC(new Date(props.audit.startMonth));

    startMonth.value = {
        month: date.getMonth(),
        year: date.getFullYear(),
    };

    date = convertToUTC(new Date(props.audit.endMonth));

    endMonth.value = {
        month: date.getMonth(),
        year: date.getFullYear(),
    };

    isShowEditEditor.value = true;
};
const hideEditEditor = function () {
    isShowEditEditor.value = false;
};

const updateAudit = async () => {
    if (await handleSubmit(schema, editAudit.value)) {
        await auditStore.update(props.id, editAudit.value!);
        await fetchDetails();
        await hideEditEditor();
    }
};

onMounted(() => {
    editAudit.value = <AuditEdit>(<unknown>clone(props.audit));
});

const fetchDetails = async () => {
    emit("reload");
};

const startMonth = ref();
const endMonth = ref();

watch(startMonth, (newStartMonth) => {
    editAudit.value!.startMonth = convertToUTC(new Date(newStartMonth.year, newStartMonth.month, 1));
});

watch(endMonth, (newEndMonth) => {
    editAudit.value!.endMonth = convertToUTC(new Date(newEndMonth.year, newEndMonth.month + 1, 0));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(InformationModal, {
      title: "Upload Report",
      "show-modal": isShowUploadReport.value,
      onDismiss: hideUploadReport
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(uploadReport, ["prevent"])
        }, [
          _createElementVNode("fieldset", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-md-3" }, [
                _createElementVNode("label", {
                  for: "uploadReportFile",
                  class: "col-form-label"
                }, "File:")
              ], -1)),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(FileInput, {
                  modelValue: uploadReportFile.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((uploadReportFile).value = $event)),
                  id: "uploadReportFile",
                  name: "uploadReportFile",
                  error: _unref(errors).file
                }, null, 8, ["modelValue", "error"])
              ])
            ])
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Cancel "),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary"
            }, " Save ")
          ], -1))
        ], 32)
      ]),
      _: 1
    }, 8, ["show-modal"]),
    (editAudit.value)
      ? (_openBlock(), _createBlock(InformationModal, {
          key: 0,
          title: "Edit Audit",
          "show-modal": isShowEditEditor.value,
          onDismiss: hideEditEditor
        }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _withModifiers(updateAudit, ["prevent"])
            }, [
              _createElementVNode("fieldset", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", {
                    for: "disabledSelect",
                    class: "col-sm-3 col-form-label"
                  }, "Agency:", -1)),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(editAudit.value.agencyName), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", {
                    for: "disabledTextInput",
                    class: "col-sm-3 col-form-label"
                  }, "Period Under Review:", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _cache[11] || (_cache[11] = _createElementVNode("label", {
                          for: "startMonth",
                          class: "col-form-label"
                        }, "Start Month:", -1)),
                        _createVNode(_unref(BDatePicker), {
                          name: "startMonth",
                          "month-picker": true,
                          error: _unref(errors).startMonth,
                          modelValue: startMonth.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startMonth).value = $event))
                        }, null, 8, ["error", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _cache[12] || (_cache[12] = _createElementVNode("label", {
                          for: "endMonth",
                          class: "col-form-label"
                        }, "End Month:", -1)),
                        _createVNode(_unref(BDatePicker), {
                          name: "endMonth",
                          "month-picker": true,
                          error: _unref(errors).endMonth,
                          modelValue: endMonth.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((endMonth).value = $event))
                        }, null, 8, ["error", "modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", {
                    for: "disabledTextInput",
                    class: "col-sm-3 col-form-label"
                  }, "Audit to Take Place:", -1)),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[14] || (_cache[14] = _createElementVNode("label", {
                          for: "startDate",
                          class: "col-form-label"
                        }, "Start Date:", -1)),
                        _createVNode(_unref(BDatePicker), {
                          name: "startDate",
                          error: _unref(errors).startDate,
                          modelValue: editAudit.value.startDate,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editAudit.value.startDate) = $event))
                        }, null, 8, ["error", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", {
                          for: "plannedEndDate",
                          class: "col-form-label"
                        }, "End Date:", -1)),
                        _createVNode(_unref(BDatePicker), {
                          name: "plannedEndDate",
                          error: _unref(errors).plannedEndDate,
                          modelValue: editAudit.value.plannedEndDate,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editAudit.value.plannedEndDate) = $event))
                        }, null, 8, ["error", "modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", {
                    for: "auditorName",
                    class: "col-sm-3 col-form-label"
                  }, "Auditor Name:", -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_unref(BInput), {
                      name: "auditorName",
                      type: "text",
                      modelValue: editAudit.value.auditorName,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editAudit.value.auditorName) = $event)),
                      error: _unref(errors).auditorName
                    }, null, 8, ["modelValue", "error"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", {
                    for: "auditorEmailAddress",
                    class: "col-sm-3 col-form-label"
                  }, "Auditor Email Address:", -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_unref(BInput), {
                      name: "auditorEmailAddress",
                      type: "text",
                      modelValue: editAudit.value.auditorEmailAddress,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editAudit.value.auditorEmailAddress) = $event)),
                      error: _unref(errors).auditorEmailAddress
                    }, null, 8, ["modelValue", "error"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", {
                    for: "disabledSelect",
                    class: "col-sm-3 col-form-label"
                  }, "Notices:", -1)),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(AuditDetailsNotices, {
                      "run-audits": _ctx.runAudits,
                      modelValue: editAudit.value.notices,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editAudit.value.notices) = $event)),
                      "create-audits": _ctx.createAudits,
                      audit: _ctx.audit,
                      id: _ctx.id
                    }, null, 8, ["run-audits", "modelValue", "create-audits", "audit", "id"])
                  ])
                ])
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  "data-bs-dismiss": "modal"
                }, " Cancel "),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  type: "submit"
                }, " Save ")
              ], -1))
            ], 32)
          ]),
          _: 1
        }, 8, ["show-modal"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("table", _hoisted_24, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _cache[21] || (_cache[21] = _createElementVNode("th", null, "Agency:", -1)),
            _createElementVNode("td", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.audit.agencyName), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _cache[22] || (_cache[22] = _createElementVNode("th", null, "Status:", -1)),
            _createElementVNode("td", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.audit.status), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _cache[24] || (_cache[24] = _createElementVNode("th", null, "Period Under Review:", -1)),
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_25, [
                _createTextVNode(_toDisplayString(_ctx.audit.startMonth) + " ", 1),
                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "me-1 ms-1" }, " through ", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.audit.endMonth), 1)
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _cache[26] || (_cache[26] = _createElementVNode("th", null, "Audit to Take Place:", -1)),
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_26, [
                _createTextVNode(_toDisplayString(_ctx.audit.startDate) + " ", 1),
                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "me-1 ms-1" }, " to ", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.audit.plannedEndDate), 1)
              ])
            ])
          ]),
          _cache[30] || (_cache[30] = _createElementVNode("tr", null, [
            _createElementVNode("th", null, "Auditor Contact Details:")
          ], -1)),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "col col-auto col-title" }, [
                    _createElementVNode("span", { class: "title-bold" }, "Name:")
                  ], -1)),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.audit.auditorName), 1)
                  ])
                ]),
                (_ctx.audit.auditorEmailAddress)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col col-auto col-title" }, [
                        _createElementVNode("span", { class: "title-bold" }, "Email:")
                      ], -1)),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.audit.auditorEmailAddress), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _cache[29] || (_cache[29] = _createElementVNode("th", null, "Notices:", -1)),
            _createElementVNode("td", null, [
              (_ctx.audit.notifications)
                ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.audit.notifications) + " notice types enabled", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_36, "No notice type enabled"))
            ])
          ])
        ])
      ]),
      (canEdit.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            onClick: _withModifiers(showEditEditor, ["prevent"]),
            class: "btn btn-primary me-2"
          }, " Edit "))
        : _createCommentVNode("", true),
      (canShowClose.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            onClick: _withModifiers(closeAudit, ["prevent"]),
            class: "btn btn-danger me-2"
          }, " Close Audit "))
        : _createCommentVNode("", true),
      (canUploadReport.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            onClick: showUploadReport,
            class: "btn btn-primary me-2"
          }, " Upload Report "))
        : _createCommentVNode("", true),
      (canShowCancel.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            type: "button",
            onClick: _withModifiers(closeAudit, ["prevent"]),
            class: "btn btn-danger me-2"
          }, " Cancel Audit "))
        : _createCommentVNode("", true),
      (canViewReport.value)
        ? (_openBlock(), _createElementBlock("a", {
            key: 4,
            href: `api/v1/audit/file/${_ctx.audit.reportFileId}`,
            class: "btn btn-secondary"
          }, "View Report", 8, _hoisted_37))
        : _createCommentVNode("", true),
      (canReplaceReport.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 5,
            type: "button",
            onClick: showUploadReport,
            class: "btn btn-primary mx-2"
          }, " Replace Report "))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})